/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import { ORGANIZATION_REPORT_STATUS } from "../../OrganizationReportUIHelpers";

export const ActionsColumnFormatter = (
  cellContent,
  row,
  rowIndex,
  {
    openEditOrganizationReportPage,
    openDeleteOrganizationReportPage,
    setToDelete,
    allowEdit,
    allowDelete
  }
) => (
  <>
    {/* {allowEdit && ( */}
    <OverlayTrigger
      overlay={<Tooltip id="products-edit-tooltip">Detail Laporan</Tooltip>}
    >
      <a
        className="btn btn-icon btn-light btn-hover-primary btn-sm mx-3"
        onClick={() => openEditOrganizationReportPage(row.uuid)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <i className="fa fa-eye"></i>
          {/* <SVG
            src={toAbsoluteUrl("/media/svg/icons/Communication/Write.svg")}
          /> */}
        </span>
      </a>
    </OverlayTrigger>
    {/* )} */}

    {row.status == ORGANIZATION_REPORT_STATUS.DRAFT && (
      <OverlayTrigger
        overlay={<Tooltip id="products-delete-tooltip">Hapus Laporan</Tooltip>}
      >
        <a
          className="btn btn-icon btn-light btn-hover-danger btn-sm"
          onClick={() => {
            setToDelete(row);
            openDeleteOrganizationReportPage(row);
          }}
        >
          <span className="svg-icon svg-icon-md svg-icon-danger">
            <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")} />
          </span>
        </a>
      </OverlayTrigger>
    )}

    <> </>
    {/*<OverlayTrigger*/}
    {/*    overlay={<Tooltip id="products-delete-tooltip">Delete donatur</Tooltip>}*/}
    {/*>*/}
    {/*    <a*/}
    {/*        className="btn btn-icon btn-light btn-hover-danger btn-sm"*/}
    {/*        onClick={() => console.log('deleted id : ', row.uuid)}*/}
    {/*    >*/}
    {/*<span className="svg-icon svg-icon-md svg-icon-danger">*/}
    {/*  <SVG src={toAbsoluteUrl("/media/svg/icons/General/Trash.svg")}/>*/}
    {/*</span>*/}
    {/*    </a>*/}
    {/*</OverlayTrigger>*/}
  </>
);
